import { Button, Modal } from "antd";
import Breadcrumb from "../components/Breadcrumb";
import { useState } from "react";

function Videos() {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [videoLink, setVideoLink] = useState('');
    const showModal = (thisVideoLink) => {
        setIsModalOpen(true);
        setVideoLink(thisVideoLink)
    };
    const handleCancel = () => {
        setVideoLink('');
        setIsModalOpen(false);
    };
    return (
        <>
            <Breadcrumb text="Videolar" />
            <Modal
                title="Video"
                centered
                cancelText="Yopish"
                open={isModalOpen}
                onCancel={handleCancel}
                footer={null}
                width={1000}
            >
                <iframe
                    width={"100%"}
                    style={{ aspectRatio: '16/9' }}
                    className="mfp-iframe rounded"
                    src={videoLink}
                    frameborder="0"
                    allowFullScreen=""
                ></iframe>
            </Modal>
            <section class="our-best-team my-120">
                <div class="container-xl">
                    <div class="section-title center">
                        <div class="section-title-inner center">
                            <h4 class="sub-title">Videodarslar</h4>
                            <h2 class="big-title s-color-black">Barcha videodarslar</h2>
                        </div>
                    </div>
                    <div class="our-best-team-content v1">
                        <div class="row">
                            <div class="col-lg-4 col-md-6 col-sm-6">
                                <div class="team-img">
                                    <img
                                        src="/assets/images/courses-img-7.jpg"
                                        alt="team-member-img"
                                    />
                                    <div class="team-content">
                                        <div class="left-data">
                                            <p class="team-para">Media maydon va internet imkoniyatlari</p>
                                        </div>
                                        <div class="team-share-box">
                                            <div class="share">
                                                <Button
                                                    type="primary"
                                                    onClick={() => showModal('https://www.youtube.com/embed/MV6PeF3gm-Q')}>
                                                    <i class="my-icon icon-play"></i>
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6 col-sm-6">
                                <div class="team-img">
                                    <img
                                        src="/assets/images/courses-img-8.jpg"
                                        alt="team-member-img"
                                    />
                                    <div class="team-content">
                                        <div class="left-data">
                                            <p class="team-para">
                                                Virtual o'yinlarning yoshlar ongiga ta'siri
                                            </p>
                                        </div>
                                        <div class="team-share-box">
                                            <div class="share">
                                                <Button
                                                    type="primary"
                                                    onClick={() => showModal('https://www.youtube.com/embed/eVAG6LK046Q')}>
                                                    <i class="my-icon icon-play"></i>
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6 col-sm-6">
                                <div class="team-img">
                                    <img
                                        src="/assets/images/courses-img-2.jpg"
                                        alt="team-member-img"
                                    />
                                    <div class="team-content">
                                        <div class="left-data">
                                            <p class="team-para">
                                                Ijtimoiy tarmoqlarda axborot xurujlari
                                            </p>
                                        </div>
                                        <div class="team-share-box">
                                            <div class="share">
                                                <Button
                                                    type="primary"
                                                    onClick={() => showModal('https://www.youtube.com/embed/l6CI0WaBio0')}>
                                                    <i class="my-icon icon-play"></i>
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6 col-sm-6">
                                <div class="team-img">
                                    <img
                                        src="/assets/images/courses-img-2.jpg"
                                        alt="team-member-img"
                                    />
                                    <div class="team-content">
                                        <div class="left-data">
                                            <p class="team-para">
                                                Mediasavodxonlik va axborot madaniyati evolyutsiyasi va uning jamiyatdagi ahamiyati
                                            </p>
                                        </div>
                                        <div class="team-share-box">
                                            <div class="share">
                                                <Button
                                                    type="primary"
                                                    onClick={() => showModal('https://www.youtube.com/embed/SoIDOIBiFmE')}>
                                                    <i class="my-icon icon-play"></i>
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6 col-sm-6">
                                <div class="team-img">
                                    <img
                                        src="/assets/images/courses-img-7.jpg"
                                        alt="team-member-img"
                                    />
                                    <div class="team-content">
                                        <div class="left-data">
                                            <p class="team-para">
                                                Xorijiy ommaviy axborot vositalarining media makonidagi o‘rni
                                            </p>
                                        </div>
                                        <div class="team-share-box">
                                            <div class="share">
                                                <Button
                                                    type="primary"
                                                    onClick={() => showModal('https://www.youtube.com/embed/q8A9iT8fO1A')}>
                                                    <i class="my-icon icon-play"></i>
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6 col-sm-6">
                                <div class="team-img">
                                    <img
                                        src="/assets/images/courses-img-8.jpg"
                                        alt="team-member-img"
                                    />
                                    <div class="team-content">
                                        <div class="left-data">
                                            <p class="team-para">
                                                Axborotning jamiyatdagi o‘rni va ahamiyati
                                            </p>
                                        </div>
                                        <div class="team-share-box">
                                            <div class="share">
                                                <Button
                                                    type="primary"
                                                    onClick={() => showModal('https://www.youtube.com/embed/fqUcAF46xpA')}>
                                                    <i class="my-icon icon-play"></i>
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Videos;
